
import React from 'react';

const GenericOutput = ({column, value}) => {
  switch(column.type) {
    case 'timestamp':
      return (value ? value.toString() : '');
    case 'boolean':
      return (value ? value.toString() : 'false');
    case 'number':
      return (value ? value.toString() : '');
    case 'file':
      return (value ? value.toString() : '');
    default:
      return (value ? value.toString() : '');
  }
};

export default GenericOutput;
